"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CALENDAR_UPDATED = exports.CALENDAR_UNREGISTERED = exports.CALENDAR_REGISTERED = exports.CALENDAR_DELETE = exports.CALENDAR_CREATE = exports.CALENDAR = void 0;
var CALENDAR_REGISTERED = 'calendar:registered';
exports.CALENDAR_REGISTERED = CALENDAR_REGISTERED;
var CALENDAR_UNREGISTERED = 'calendar:unregistered';
exports.CALENDAR_UNREGISTERED = CALENDAR_UNREGISTERED;
var CALENDAR_UPDATED = 'calendar:update';
exports.CALENDAR_UPDATED = CALENDAR_UPDATED;
var CALENDAR_DELETE = 'calendar:delete';
exports.CALENDAR_DELETE = CALENDAR_DELETE;
var CALENDAR_CREATE = 'calendar:create';
exports.CALENDAR_CREATE = CALENDAR_CREATE;
var CALENDAR = 'CALENDAR';
exports.CALENDAR = CALENDAR;
//# sourceMappingURL=constants.js.map
